module.exports = __webpack_public_path__ + "images/emoji/tea.ced5b16ced07bacf0d6d.png";